<template>
  <div class="content">
    <!-- 面包屑 -->
    <!-- <div class="breadcrumb">
      <i class="iconfont icondqwz"></i>
      <ul>
        <li class="active">设备控制管理</li>
      </ul>
    </div>-->
    <!-- tab页 -->
    <el-tabs class="tabLv3" type="border-card" v-model="tabName">
      <i class="lt"></i>
      <i class="rt"></i>
      <el-tab-pane name="jsgl">
        <span slot="label">
          <i class="iconfont iconcheck"></i>
          <i class="border"></i> 指令下发
        </span>
        <div class="w_normalNav">
          <button class="BlueSmBtn" @click="subSeefrom">搜索</button>
          <button class="OrangeSmBtn" @click="reset">重置</button>
          <button class="GreenSmBtn" @click="control">远程控制</button>
        </div>
        <div class="searchForm1">
          <searchForm :items="items" :formPlus="form_jsgl" ref="searchForm_jsgl">
            <template slot="last">
              <el-form-item label="设备类型">
                <el-select placeholder="请选择设备类型" v-model="seefrom.deviceType">
                  <el-option
                    v-for="item in options"
                    :key="item.id"
                    :label="item.typeName"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="设备编码">
                <el-input placeholder="请输入设备编码" v-model="seefrom.device_mark"></el-input>
              </el-form-item>
              <el-form-item label="设备区域">
                <el-input
                  placeholder="请选择区域"
                  v-model="seefrom.curAreaName"
                  @focus="changeAreaMode(1)"
                ></el-input>
              </el-form-item>
            </template>
          </searchForm>
        </div>
        <div class="tableWrapper" v-loading="!showTable">
          <!-- 后端分页 -->
          <easyTable
            apiUrl="operation/device/list"
            :parent="self"
            :config="config"
            :other="other"
            ref="instructions"
          >
            <template slot="last">
              <el-table-column label="选择操作" align="center">
                <template slot-scope="scope">
                  <el-button
                    :type="scope.row.connect?'primary':'default'"
                    :plain="scope.row.connect?false:true"
                    size="small"
                    @click="fConnect(scope)"
                  >{{scope.row.connect?'已选中':'未选择'}}</el-button>
                </template>
              </el-table-column>
            </template>
          </easyTable>
        </div>
        <!-- dialog -->
        <el-dialog
          class="instructionDialog"
          :visible.sync="formVisible"
          :title="title"
          :close-on-click-modal="false"
        >
          <el-form :model="instruction">
            <el-form-item label="名称">
              <el-select
                class="init_input"
                placeholder="请选择名称"
                v-model="instruction.name"
                @change="getInstruction"
              >
                <el-option v-for="i in option1" :key="i.id" :label="i.name" :value="i.name"></el-option>
              </el-select>
            </el-form-item>
            <!-- <el-form-item label="指令名称">
              <el-select
                class="init_input"
                placeholder="请选择指令名称"
                v-model="instruction.serviceName"
                @change="getParameter"
              >
                <el-option
                  v-for="item in option2"
                  :key="item.id"
                  :label="item.serviceName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>-->
            <el-form-item label="参数配置">
              <div v-for="a in selectParameter" :key="a.id">
                <el-col :span="11">
                  <el-form-item class="update_name" label="名称">
                    <el-input v-model="a.name"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="11">
                  <el-form-item class="update_value" label="默认值">
                    <el-input v-model="a.value" :disabled="parameter_value"></el-input>
                  </el-form-item>
                </el-col>
              </div>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button class="cancelButton" @click="formVisible = false">取 消</el-button>
            <el-button class="confirmButton" type="primary" @click="submitForm">确 定</el-button>
          </div>
        </el-dialog>

        <!-- 区域树 -->
        <mountPoint
          :hasChildNodes="areaTreeMode"
          :dialogVisible="areaTreeVisible"
          @regionTreeClose="areaTreeVisible=false"
          @regionTreeData="selRegionData"
        ></mountPoint>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  data() {
    return {
      parameter_value: false,
      row_deviceType: [],
      title: "",
      tabName: "jsgl",
      loading: true,
      form_jsgl: {},
      showTable: true,
      formVisible: false,
      items: [],
      //区域树
      areaTreeVisible: false,
      //区域树模式选择
      areaTreeMode: true,
      //设备类型
      options: [],
      //服务类型
      option1: [],
      //指令名称
      option2: [],
      //设备类型
      aDevice: [],
      idDevice: [],
      //参数配置
      Parameter: [],
      selectParameter: [],
      seefrom: {
        deviceType: "",
        device_mark: "",
        curAreaName: "",
        region_id: ""
      },
      instruction: {
        id: "",
        name: "",
        serviceType: "",
        serviceName: ""
      },
      other: {}
    };
  },
  computed: {
    self() {
      return this;
    },
    config() {
      return [
        {
          prop: "deviceName",
          label: "设备名称"
        },
        {
          prop: "deviceId",
          label: "设备编码"
        },
        {
          prop: "region",
          label: "区域"
        }
      ];
    }
  },
  components: {
    normalNav: () => import("public/normalNav"),
    searchForm: () => import("public/searchForm"),
    easyTable: () => import("public/easyTable"),
    mountPoint: () => import("public/mountPoint")
  },
  methods: {
    //搜索
    subSeefrom() {
      this.other = this.seefrom;
      this.$nextTick(this.$refs.instructions.getData);
    },
    //重置
    reset() {
      this.seefrom.deviceType = "";
      this.seefrom.device_mark = "";
      this.seefrom.curAreaName = "";
      this.seefrom.region_id = "";
    },
    //选择区域模式变化
    changeAreaMode(mode) {
      this.areaTreeVisible = true;
      if (mode === 1) this.areaTreeMode = true;
      if (mode === 2) this.areaTreeMode = false;
      this.areaMode = mode;
    },
    //区域树选择完回调
    selRegionData(a, ...b) {
      let mode = this.areaMode;
      if (mode === 1) {
        this.seefrom.region_id = a.id;
        this.seefrom.curAreaName = a.name;
      } else if (mode === 2) {
        if (!a.type || a.type !== 1) {
          this.$set(this.addEquipment, "region", null);
          this.addEquipment.regionName = "";
          return;
        }
        this.$set(this.addEquipment, "region", a.id);
        this.addEquipment.regionName = a.name;
      }
    },
    fConnect(value) {
      this.row_deviceType = value.row;
      let list = value.row;
      if (
        this.aDevice.some(({ deviceType }) => deviceType != list.deviceType)
      ) {
        this.$notify({
          title: "警告!不能选择不同类型的设备",
          type: "warning"
        });
        return;
      }
      this.$set(list, "connect", list.connect ? !list.connect : true);
      let connect = list.connect;
      if (connect) {
        this.aDevice.push(list);
      } else {
        let i = this.aDevice.findIndex(it => value.row.id === it.id);
        this.aDevice.splice(i, 1);
      }
    },
    //远程控制
    control() {
      if (this.aDevice.length < 1) {
        this.$notify({
          title: "至少选择一个设备",
          type: "warning"
        });
        return;
      }

      this.formVisible = true;
      this.title = "指令下发";
      this.instruction.serviceType = "";
      this.instruction.serviceName = "";
      this.instruction.name = "";
      this.Parameter = [];
      this.$axiosget("manager/devicetype/servicetype", {
        params: {
          deviceType: this.row_deviceType.deviceType
        }
      }).then(res => {
        this.option1 = res.data.data;
      });
    },
    // getParameter() {
    //   //清空
    //   this.Parameter = [];
    //   this.$axiosget("manager/devicetype/commandname", {
    //     params: {
    //       id: this.instruction.serviceName
    //     }
    //   }).then(res => {
    //     this.Parameter = res.data.data;
    //   });
    // },
    getInstruction(type) {
      //清空
      this.Parameter = [];
      this.option1.forEach(item => {
        if (type === item.name) {
          this.instruction.serviceType = item.serviceType;
          this.instruction.serviceName = item.serviceName;
          this.instruction.id = item.id;
        }
      });
      this.$axiosget("manager/devicetype/commandname", {
        params: {
          id: this.instruction.id
        }
      }).then(res => {
        this.Parameter = res.data.data;
        if (this.Parameter.find(it => it.status === 1)) {
          this.selectParameter.push(it);
        }
        //console.log(this.selectParameter,"Par")
      });
      if (this.Parameter.status === 0) {
        this.parameter_value = true;
      } else {
        this.parameter_value = false;
      }
      //console.log(this.parameter_value, "是否可以修改");
    },
    //确认
    submitForm() {
      const formdata = new Object();
      let character = "";
      this.idDevice = [];
      this.aDevice.forEach(id => {
        this.idDevice.push(id.deviceId);
      });
      character = this.idDevice.join(",");
      formdata.deviceId = character;
      formdata.deviceType = this.row_deviceType.deviceType;
      formdata.serviceType = this.instruction.serviceType;
      formdata.serviceName = this.instruction.serviceName;
      formdata.type = 0;
      formdata.domains = this.Parameter;
      this.$axiospost("operation/command/add", formdata).then(res => {
        if (Object.is(res.data.status, "10000")) {
          // this.$message.success(
          //   "指令下发请求提交成功，将跳转到指令记录页面查询执行状态！"
          // );
          // this.$router.push({
          //   path: `main/allControl/instructions_record`
          // });
          this.formVisible = false;
          this.$message.success("指令下发请求提交成功");
        } else {
          this.$message.fail("指令下发请求提交失败");
        }
      });
    }
  },
  created() {
    this.$axiosget("manager/devicetype/list").then(res => {
      this.options = res.data.data;
    });
  }
};
</script>

<style lang="less" scoped>
.w_normalNav {
  padding-top: 10px;
  height: 52px;
  position: absolute;
  top: -52px;
  right: 32px;
  z-index: 99;
}
.instructionDialog {
  .el-dialog {
    width: 586px;
  }
  .el-form-item {
    margin-top: 10px;
    margin-bottom: 0;
  }
  .el-form-item__label {
    color: #ccc;
    width: 138px;
    text-align: right;
  }
  .el-dialog__header {
    border-bottom: 1px solid #2d374d;
  }
  .el-dialog__body {
    padding-top: 45px;
  }
  .el-dialog__footer {
    padding-right: 116px;
    margin-top: 23px;
  }
  .el-dialog__title {
    border-bottom: 2px solid #35b9f7;
    font-size: 16px;
    display: inline-block;
    height: 52px;
    line-height: 52px;
    position: relative;
    top: -20px;
  }
  .el-input__inner {
    border: 1px solid #3d4963;
    border-radius: 0;
  }
  .init_input {
    width: 310px;
  }
  .update_name {
    .el-form-item__content {
      width: 140px;
    }
    .el-form-item__label {
      text-align: center;
    }
  }
  .update_value {
    margin-left: 30px;
    .el-form-item__content {
      width: 140px;
    }
    .el-form-item__label {
      text-align: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute3/management/instructions/instruction.vue